import {Text, InlineLink} from '@primer/react-brand/esm'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, INLINES, MARKS, type Document} from '@contentful/rich-text-types'
import {documentToPlainTextString, getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {codeMarkRenderer} from '@github-ui/swp-core/components/contentful/shared/RichTextFieldRenderer'
import {renderWithNewlines} from '../../utils/richtext'

export const getDescription = (description: Document, variant: 'default' | 'muted' = 'default') => {
  return documentToReactComponents(description, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Text variant={variant}>{children}</Text>,
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <InlineLink
            href={node.data.uri}
            {...getAnalyticsEvent({
              action: documentToPlainTextString(node, ' '),
              tag: 'hyperlink',
              location: 'Flex Suite Hero Description',
            })}
          >
            {children}
          </InlineLink>
        )
      },
    },
    renderMark: codeMarkRenderer,
  })
}

export const getHeading = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderText: text => renderWithNewlines(text),
    renderMark: {
      [MARKS.BOLD]: text => <b>{text}</b>,
      ...codeMarkRenderer,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
  })
}
